<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'USERS', url: '/admin/users' },
    { label: 'UPDATE_USER' }
  ]"
></breadcrumbs>
<page-header title="UPDATE_USER"></page-header>

<card>
  <form
    autocomplete="off"
    action=""
    class="form m-0"
    style="width: 600px; max-width: 100%"
    #form
  >
    <div class="columns mb-0">
      <div class="column pb-0">
        <div class="field">
          <label class="label" translationEditableDirective="FIRST_NAME">{{
            'FIRST_NAME' | translate
          }}</label>
          <div class="control">
            <input
              class="input is-small"
              name="firstName"
              type="text"
              (input)="handleFieldChange($event)"
              placeholder="e.g Alex"
              [value]="getField(['firstName'])"
              [ngClass]="{ 'is-danger': hasError('firstName') }"
            />
          </div>
          <p class="help is-danger" *ngIf="hasError('firstName')">
            {{ getError('firstName') }}
          </p>
        </div>
      </div>
      <div class="column pb-0">
        <div class="field">
          <label class="label" translationEditableDirective="LAST_NAME">{{
            'LAST_NAME' | translate
          }}</label>
          <div class="control">
            <input
              class="input is-small"
              name="lastName"
              type="text"
              (input)="handleFieldChange($event)"
              placeholder="e.g Smith"
              [value]="getField(['lastName'])"
              [ngClass]="{ 'is-danger': hasError('lastName') }"
            />
          </div>
          <p class="help is-danger" *ngIf="hasError('lastName')">
            {{ getError('lastName') }}
          </p>
        </div>
      </div>
    </div>

    <div class="columns mb-0">
      <div class="column pb-0">
        <div class="field">
          <label class="label" translationEditableDirective="ROLE">{{
            'ROLE' | translate
          }}</label>
          <div class="control">
            <ng-select
              [items]="roles"
              [multiple]="true"
              [closeOnSelect]="false"
              (change)="handleFieldChange($event, 'roles')"
              [ngClass]="{ 'is-danger': hasError('roles') }"
              [ngModel]="getField(['roles']) | array"
              [ngModelOptions]="{ standalone: true }"
              bindLabel="title"
              class="is-small"
            >
            </ng-select>
          </div>
          <p class="help is-danger" *ngIf="hasError('roles')">
            {{ getError('roles') }}
          </p>
        </div>
      </div>
      <div class="column pb-0">
        <div class="field">
          <label
            class="label"
            translationEditableDirective="FINANCIAL_INSTITUTION"
            >{{ 'FINANCIAL_INSTITUTION' | translate }}</label
          >
          <div class="control">
            <ng-select
              [items]="financialInstitutions"
              [multiple]="false"
              [closeOnSelect]="true"
              (change)="handleFieldChange($event?.id, 'financialInstitutionId')"
              [ngClass]="{
                'is-danger': hasError('financialInstitutionId')
              }"
              [ngModel]="getField(['financialInstitution']) | array"
              [ngModelOptions]="{ standalone: true }"
              bindLabel="name"
              [typeahead]="onFinancialInstitutionAutocomplete$"
              autocomplete="off"
              class="is-small"
            >
            </ng-select>
          </div>
          <p class="help is-danger" *ngIf="hasError('financialInstitutionId')">
            {{ getError('financialInstitutionId') }}
          </p>
        </div>
      </div>
    </div>

    <div class="columns mb-0">
      <div class="column pb-0">
        <div class="field">
          <label class="label" translationEditableDirective="TWO_FACTOR_AUTH">{{
            'TWO_FACTOR_AUTH' | translate
          }}</label>
          <div class="control">
            <chip
              [checked]="getField(['twoFactorAuth'])"
              (onChange)="checkboxChange($event, 'twoFactorAuth')"
              [value]="!getField(['twoFactorAuth'])"
            >
              <span
                [translationEditableDirective]="
                  (getField(['twoFactorAuth']) ? 'ENABLED' : 'DISABLED')
                    | translate
                "
              >
                {{
                  (getField(['twoFactorAuth']) ? 'ENABLED' : 'DISABLED')
                    | translate
                }}
              </span>
            </chip>
          </div>
        </div>
      </div>
      <div class="column pb-0">
        <div class="field is-narrow">
          <label class="label" translationEditableDirective="ACCOUNT_STATUS">{{
            'ACCOUNT_STATUS' | translate
          }}</label>
          <div class="control">
            <chip
              [checked]="getField(['suspended'])"
              (onChange)="checkboxChange($event, 'suspended')"
              [value]="!getField(['suspended'])"
            >
              <span
                [translationEditableDirective]="
                  (getField(['suspended']) ? 'SUSPENDED' : 'ACTIVE') | translate
                "
              >
                {{
                  (getField(['suspended']) ? 'SUSPENDED' : 'ACTIVE') | translate
                }}
              </span>
            </chip>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div>
      <h5 translationEditableDirective="UPDATE_PASSWORD">
        {{ 'UPDATE_PASSWORD' | translate }}
      </h5>

      <div class="columns mb-0">
        <div class="column pb-0">
          <div class="field">
            <label class="label" translationEditableDirective="PASSWORD">{{
              'PASSWORD' | translate
            }}</label>
            <div class="control">
              <input
                class="input is-small"
                type="password"
                (input)="handleFieldChange($event.target.value, 'password')"
                [value]="getField(['password'])"
                [ngClass]="{ 'is-danger': hasError('password') }"
                autocomplete="new-password"
                name="pass"
              />
            </div>
            <p class="help is-danger" *ngIf="hasError('password')">
              {{ getError('password') }}
            </p>
          </div>
        </div>
        <div class="column pb-0">
          <div class="field">
            <label
              class="label"
              translationEditableDirective="CONFIRM_PASSWORD"
              >{{ 'CONFIRM_PASSWORD' | translate }}</label
            >
            <div class="control">
              <input
                class="input is-small"
                type="password"
                autocomplete="confirm-password"
                (input)="
                  handleFieldChange($event.target.value, 'confirm_password')
                "
                name="conf_pass"
                [value]="getField(['confirm_password'])"
                [ngClass]="{ 'is-danger': hasError('confirm_password') }"
              />
            </div>
            <p class="help is-danger" *ngIf="hasError('confirm_password')">
              {{ getError('confirm_password') }}
            </p>
          </div>
        </div>
      </div>

      <div class="field is-grouped">
        <div class="control">
          <button
            [disabled]="isPasswordUpdating"
            type="button"
            (click)="updatePassword()"
            class="button is-success"
            translationEditableDirective="UPDATE_PASSWORD"
          >
            {{ 'UPDATE_PASSWORD' | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SUBMIT"
      (click)="onSubmit($event)"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/users']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
